import React, { useState } from 'react';
import '../styles/Auth.css';
import { resetPassword } from '../api/auth';

// Shown when the app is opened via a reset link (/?reset=TOKEN).
function ResetPassword({ token, onDone }) {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== confirm) { setError('Passwords do not match.'); return; }
    setLoading(true);
    try {
      await resetPassword(token, password);
      setDone(true);
    } catch (err) {
      setError(err.message || 'Could not reset password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Set a new password</h2>
        {done ? (
          <>
            <div className="send-notice" style={{ marginBottom: 16 }}>
              Password reset. You can now sign in with your new password.
            </div>
            <button type="button" className="btn btn-primary" onClick={onDone}>Go to sign in</button>
          </>
        ) : (
          <form onSubmit={submit} className="auth-form">
            <div className="form-group">
              <label htmlFor="newpw">New password</label>
              <input id="newpw" type="password" value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="At least 8 chars, a letter and a number" required />
            </div>
            <div className="form-group">
              <label htmlFor="confirmpw">Confirm new password</label>
              <input id="confirmpw" type="password" value={confirm}
                onChange={(e) => setConfirm(e.target.value)} placeholder="••••••••" required />
            </div>
            {error && <div className="error-message">{error}</div>}
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Saving…' : 'Reset password'}
            </button>
          </form>
        )}
        <div className="auth-toggle">
          <button type="button" className="link-button" onClick={onDone}>Back to sign in</button>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
